module.exports = __webpack_public_path__ + "static/img/home2.84629376.png";